import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import HsCodeRemarkService from "../../Services/HsCodeRemarkService";

export const EditHsCodeRemarks = ({ item, setShow, getData }) => {
  const [loader, setLoader] = useState(false);
  const history = useHistory();

  const initialValues = {
    remarks: "",
  };

  const validationSchema = Yup.object().shape({
    remarks: Yup.string().required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoader(true);
      values = { ...values, id: item._id };
      HsCodeRemarkService.updateHscoderemark(values).then((res) => {
        if (res.status) {
          toast.success(res.msg);
          setLoader(false);
          setShow(false);
          getData();
        } else {
          setLoader(false);
          toast.error(res.msg);
        }
      });
    },
  });

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  useEffect(() => {
    if (item?.remarks) {
      setFieldValue("remarks", item.remarks);
    }
  }, [item]);

  return (
    <div className="row d-flex justify-content-center">
      <form className="control-form" autoComplete="off" onSubmit={handleSubmit}>
        {/* Charges  */}
        <div className="row">
          <div className="mb-3 col-12">
            <label className="form-label">Remarks</label>
            <input
              type="text"
              className={
                "form-control" +
                (touched.remarks && errors.remarks ? " is-invalid" : "")
              }
              value={values?.remarks}
              name="remarks"
              placeholder="Enter Remarks"
              {...getFieldProps("remarks")}
            />
            {touched.remarks && errors.remarks ? (
              <div className="text-danger">{errors.remarks}</div>
            ) : null}
          </div>
        </div>

        <div className="mt-3 d-flex justify-content-between">
          <button
            className="btn btn-danger w-sm waves-effect waves-light"
            type="button"
            onClick={() => setShow(false)}
          >
            Back
          </button>
          <button
            className="btn btn-primary w-sm waves-effect waves-light"
            type="submit"
          >
            Submit
          </button>
        </div>
      </form>
      <Loader isShow={loader} />
    </div>
  );
};
